import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";

import DatasetColumns from "components/Dataset/DatasetColumns";

const id = "new";

class DatasetColumnsContainer extends React.PureComponent {
  render() {
    const { dataset } = this.props;

    return <DatasetColumns {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, ownProps) => ({
  dataset: homeReducer.getDataset(state, ownProps.id)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(DatasetColumnsContainer);
